import { FlowRoute } from 'utils/FlowProvider/types'

export const SPEND_HERO_COPY = new Map([
  [
    FlowRoute.Signup,
    {
      header: 'Create your Acorns account',
      text:
        'Let’s get you set up with your all-in-one Acorns account so you can start saving and investing when you spend.',
    },
  ],
  [
    FlowRoute.Institutions,
    {
      header: 'Securely link your bank',
      text:
        'This will allow you to add money to your new Acorns Spend checking account so you can easily use your new Acorns Visa debit card.',
    },
  ],
  [
    FlowRoute.ManualFundingSource,
    {
      header: 'Link bank account',
      text:
        'Enter your information below to link your bank account so you can make your first deposit.',
    },
  ],
  [
    FlowRoute.PersonalInfo,
    {
      header: 'Tell us a little about you',
      text: 'This information helps us personalize and secure your Acorns account.',
    },
  ],
  [
    FlowRoute.Prefund,
    {
      header: 'Activate your Acorns Spend account',
      text:
        'Transfer at least $25 to your new Acorns Spend checking account so you can start using your debit card when it arrives.',
    },
  ],
  [
    FlowRoute.SpendOrderConfirmation,
    {
      header: 'Confirm your information',
      text: 'Double-check your details, then tap "Next" to confirm your information.',
    },
  ],
  [
    FlowRoute.InvestorQuestions,
    {
      header: 'Last question!',
      text: 'Do any of these apply to you?',
    },
  ],
  [
    FlowRoute.SpendCoreInterstitial,
    {
      header: 'Save and invest with every swipe',
      text:
        'Your Acorns Visa debit card instantly invests your spare change with every purchase. So let’s open up your investment account.',
    },
  ],
  [
    FlowRoute.SuitabilityQuestions,
    {
      header: 'Create your investment account',
      text:
        'Tell us about your current situation and we’ll create the right investment portfolio for you. Your spare change will get invested here. ',
    },
  ],
])
